<template>
  <Chart
    :size="{ width: width, height: height }"
    :data="plotData"
    :margin="margin"
    :direction="direction"
    :axis="axis"
    class="text-sm text-gray-over-dark"
  >
    <template #layers>
      <!-- <Grid strokeDasharray="2,2" /> -->
      <Area
        :dataKeys="['name', 'pl']"
        type="monotone"
        :areaStyle="{ fill: 'url(#grad)' }"
      />

      <Marker
        :value="chartSetupPassed.common.y_val"
        style="font-size: 9px"
        :label="
          hasAuthorityHistory.common
            ? 'Common Authority'
            : 'Common Authority (No Authority)'
        "
        :color="hasAuthorityHistory.common ? '#dfb215' : '#A9ADBD'"
        :strokeWidth="1"
        strokeDasharray="12 12"
        :strokeOpacity="1"
      />
      <Marker
        :value="chartSetupPassed.contract.y_val"
        style="font-size: 9px"
        :label="
          hasAuthorityHistory.contract
            ? 'Contract Authority'
            : 'Contract Authority (No Authority)'
        "
        :color="hasAuthorityHistory.contract ? '#dfb215' : '#A9ADBD'"
        :strokeWidth="1"
        strokeDasharray="12 12"
        :strokeOpacity="1"
      />
      <Marker
        :value="chartSetupPassed.broker.y_val"
        style="font-size: 9px"
        :label="
          hasAuthorityHistory.broker
            ? 'Broker Authority'
            : 'Broker Authority (No Authority)'
        "
        :color="hasAuthorityHistory.broker ? '#dfb215' : '#A9ADBD'"
        :strokeWidth="1"
        strokeDasharray="12 12"
        :strokeOpacity="1"
      />

      <!-- CONTRACT SVGs -->
      <Line
        :dataKeys="['nameContract', 'plContract']"
        type="monotone"
        :lineStyle="{
          stroke: '#f8c617',
          strokeWidth: 2,
        }"
        :dotStyle="{
          stroke: '#f8c617',
          r: 2,
          strokeWidth: 4,
        }"
      />

      <LabelsInsightsAuthorityHistory
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataContract"
        :key="'gap-labelContract-' + index"
        color="#ef4444"
        :ypos="index % 2 == 0 ? 30 : -30"
        :xpos="0"
        xalign="middle"
        :dataKeys="['name3', 'pl3', 'msg3']"
        :data-keys="[
          'name-labelContract' + index,
          'pl-labelContract' + index,
          'msg-labelContract' + index,
        ]"
      />

      <Line
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataContract"
        :key="'gap-lineContract-' + index"
        :dataKeys="['name-gapContract0', 'pl-gapContract0']"
        type="monotone"
        :hideDot="false"
        :class="'name-gapContract' + index"
        :data-keys="['name-gapContract' + index, 'pl-gapContract' + index]"
        :lineStyle="{
          stroke: '#ef4444',
        }"
        :dotStyle="{
          stroke: '#ef4444',
          r: 1,
          strokeWidth: 2,
        }"
      />

      <!-- END CONTRACT SVGs -->

      <!-- COMMON SVGs -->
      <Line
        :dataKeys="['nameCommon', 'plCommon']"
        type="monotone"
        :lineStyle="{
          stroke: '#f8c617',
          strokeWidth: 2,
        }"
        :dotStyle="{
          stroke: '#f8c617',
          r: 2,
          strokeWidth: 4,
        }"
      />

      <LabelsInsightsAuthorityHistory
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataCommon"
        :key="'gap-labelCommon-' + index"
        color="#ef4444"
        :ypos="index % 2 == 0 ? 30 : -30"
        :xpos="0"
        xalign="middle"
        :dataKeys="['name3', 'pl3', 'msg3']"
        :data-keys="[
          'name-labelCommon' + index,
          'pl-labelCommon' + index,
          'msg-labelCommon' + index,
        ]"
      />

      <Line
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataCommon"
        :key="'gap-lineCommon-' + index"
        :dataKeys="['name-gapCommon0', 'pl-gapCommon0']"
        type="monotone"
        :hideDot="false"
        :class="'name-gapCommon' + index"
        :data-keys="['name-gapCommon' + index, 'pl-gapCommon' + index]"
        :lineStyle="{
          stroke: '#ef4444',
        }"
        :dotStyle="{
          stroke: '#ef4444',
          r: 1,
          strokeWidth: 2,
        }"
      />

      <!-- END COMMON SVGs -->

      <!-- BROKER SVGs -->
      <Line
        :dataKeys="['nameBroker', 'plBroker']"
        type="monotone"
        :lineStyle="{
          stroke: '#f8c617',
          strokeWidth: 2,
        }"
        :dotStyle="{
          stroke: '#f8c617',
          r: 2,
          strokeWidth: 4,
        }"
      />

      <LabelsInsightsAuthorityHistory
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataBroker"
        :key="'gap-labelBroker-' + index"
        color="#ef4444"
        :ypos="index % 2 == 0 ? 30 : -30"
        :xpos="0"
        xalign="middle"
        :dataKeys="['name3', 'pl3', 'msg3']"
        :data-keys="[
          'name-labelBroker' + index,
          'pl-labelBroker' + index,
          'msg-labelBroker' + index,
        ]"
      />

      <Line
        v-for="(gap, index) in plotDataPassed[plotDataPassed.length - 1]
          .gapDataBroker"
        :key="'gap-lineBroker-' + index"
        :dataKeys="['name-gapBroker0', 'pl-gapBroker0']"
        type="monotone"
        :hideDot="false"
        :class="'name-gapBroker' + index"
        :data-keys="['name-gapBroker' + index, 'pl-gapBroker' + index]"
        :lineStyle="{
          stroke: '#ef4444',
        }"
        :dotStyle="{
          stroke: '#ef4444',
          r: 1,
          strokeWidth: 2,
        }"
      />

      <!-- END BROKER SVGs -->

      <Line
        :dataKeys="['name-x-label', 'pl-x-label', 'msg-x-label']"
        type="monotone"
        class="x-axis-data-line"
        :lineStyle="{
          stroke: '#A9ADBD',
          strokeWidth: 1,
        }"
        :dotStyle="{
          stroke: '#A9ADBD',
          r: 2,
          strokeWidth: 4,
        }"
      />

      <LabelsInsightsAuthorityHistoryXAxis
        v-for="(xAxisValue, index) in plotDataPassed[plotDataPassed.length - 2]
          .x_axis_data"
        :key="'x-axis-label-' + index"
        color="#A9ADBD"
        :ypos="5"
        :xpos="0"
        xalign="middle"
        :dataKeys="['nameX', 'plX', 'msgX']"
        :data-keys="[
          'name-x-label' + index,
          'pl-x-label' + index,
          'msg-x-label' + index,
        ]"
      />

      <!-- <LabelsInsights :dataKeys="['name2', 'pl2', 'msg']" /> -->
      <!-- <Labels :dataKeys="['name', 'pl']" /> -->
      <defs>
        <linearGradient
          id="grad"
          gradientTransform="rotate(90)"
        >
          <stop
            offset="0%"
            stop-color="#f8c617"
            stop-opacity="0"
          />
          <stop
            offset="100%"
            stop-color="white"
            stop-opacity="0.4"
          />
        </linearGradient>
      </defs>
    </template>

    <template #widgets>
      <!-- <Tooltip
        borderColor="#48CAE4"
        :config="{
          pl: { color: '#9f7aea' },
        }"
      /> -->
    </template>
  </Chart>
</template>

<script lang="ts">
// import { defineComponent,  ref, toRefs } from 'vue'
import { defineComponent, ref } from 'vue';
// import { Chart, Grid, Line, Marker, Area, usePoints } from 'vue3-charts'
import { Chart, Line, Marker, Area } from 'vue3-charts';
// import Labels from '@/components/Labels.vue'
import LabelsInsightsAuthorityHistory from './LabelsInsightsAuthorityHistory.vue';
import LabelsInsightsAuthorityHistoryXAxis from './LabelsInsightsAuthorityHistoryXAxis.vue';

export default defineComponent({
  name: 'LineChartInsights',
  // components: { Chart, Grid, Line, Marker, Area, Labels },
  components: {
    Chart,
    Line,
    Marker,
    Area,
    LabelsInsightsAuthorityHistory,
    LabelsInsightsAuthorityHistoryXAxis,
  },
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    plotData: {
      type: Array,
      required: true,
    },
    chartSetup: {
      type: Object,
      required: true,
    },
    authorityHistory: {
      type: Object,
      required: true,
    },
    top25Pct: {
      type: Number,
      required: false,
    },
    bottom25Pct: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    console.dir(this.chartSetup);
  },

  setup(props) {
    // var plByMonth = [
    //   { name: 'Jan', pl: 1000, avg: 500, inc: 300 },
    //   { name: 'Feb', pl: 2000, avg: 900, inc: 400 },
    //   { name: 'Apr', pl: 400, avg: 400, inc: 500 },
    //   { name: 'Mar', pl: 3100, avg: 1300, inc: 700 },
    //   { name: 'May', pl: 200, avg: 100, inc: 200 },
    //   { name: 'Jun', pl: 600, avg: 400, inc: 300 },
    //   { name: 'Jul', pl: 500, avg: 90, inc: 100 }
    // ]
    // const data = ref(plByMonth);
    // const width = ref(width)
    // const height = ref(height)
    // const plotData = ref(plotData)
    // const top10Pct = ref(top10Pct)
    // const bottom10Pct = ref(bottom10Pct)
    const dataLength = ref(props.plotData.length);
    const dataMaximum = ref(props.chartSetup.chart_unit_width);
    console.dir(dataMaximum);
    console.dir(dataMaximum.value);
    const direction = ref('horizontal');
    const margin = ref({
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    });

    const marker = true;
    const strokeWidth = 1;

    const plotDataPassed = ref(props.plotData);
    const chartSetupPassed = ref(props.chartSetup);
    const hasAuthorityHistory = ref(props.authorityHistory);

    const axis = ref({
      primary: {
        // domain: ['dataMin+0.7', 'dataMax + 0.3'],
        domain: ['0', 'dataMax * 1.01'],
        type: 'linear',
        ticks: dataLength.value,
      },
      secondary: {
        // domain: ['dataMin - 10', 'dataMax + 40'],
        domain: ['0', '110'],
        // domain: [ bottom10Pct * 0.8, top10Pct * 1.1 ],
        type: 'linear',
        ticks: 6,
      },
    });

    axis.value.primary.domain = ['0', dataMaximum.value * 1.08];

    return {
      direction,
      margin,
      axis,
      marker,
      strokeWidth,
      dataLength,
      plotDataPassed,
      chartSetupPassed,
      hasAuthorityHistory,
    };
  },
});
</script>

<style scoped>
g.layer-axis-x,
g.layer-axis-y {
  color: #c7cbdb;
}
g.layer-axis-x {
  display: none !important;
  height: 0px !important;
}
g.layer-axis-y > g {
  display: none !important;
}
</style>
